import { useQuery } from "@tanstack/react-query";

import { listHolidays } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";

export function useHolidayNames(year: number | undefined, enabled = true) {
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useQuery({
		queryKey: ["holidays", activeCanteiroId, year],
		enabled: enabled && activeCanteiroId != null && year != null,
		queryFn: async (): Promise<Map<string, string>> => {
			const { items } = await listHolidays(
				activeCanteiroId as string,
				year as number,
			);
			return new Map(items.map((holiday) => [holiday.date, holiday.name]));
		},
		staleTime: 5 * 60_000,
	});
}
